"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Container = _interopRequireDefault(require("@commerce-ui/core2/Container"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _parseProductDescription = _interopRequireDefault(require("@deosite/helpers/parseProductDescription"));
var __jsx = _react["default"].createElement;
var ProductDescription2Columns = function ProductDescription2Columns(props) {
  var productInfo = props.productInfo;
  var translations = {
    technicalData: (0, _langLibrary["default"])("Technical data"),
    shortDescription: (0, _langLibrary["default"])("Details"),
    length: (0, _langLibrary["default"])("Length [cm]"),
    width: (0, _langLibrary["default"])("Width [cm]"),
    shape: (0, _langLibrary["default"])("Shape"),
    producer: (0, _langLibrary["default"])("Producer"),
    height: (0, _langLibrary["default"])("Height [cm]"),
    depth: (0, _langLibrary["default"])("Depth [cm]"),
    capacity: (0, _langLibrary["default"])("Capacity [l]"),
    number_of_people: (0, _langLibrary["default"])("Number of people"),
    dajar_collection: (0, _langLibrary["default"])("Dajar collection"),
    material: (0, _langLibrary["default"])("Material"),
    application: (0, _langLibrary["default"])("Application"),
    diameter: (0, _langLibrary["default"])("Diameter [cm]"),
    color_list: (0, _langLibrary["default"])("Color list"),
    pattern_list: (0, _langLibrary["default"])("Pattern list"),
    feature: (0, _langLibrary["default"])("Feature"),
    composition: (0, _langLibrary["default"])("Composition"),
    max_load: (0, _langLibrary["default"])("Max load"),
    ean: (0, _langLibrary["default"])("Ean"),
    weight: (0, _langLibrary["default"])("Weight [kg]"),
    safetyDescription: (0, _langLibrary["default"])("safety_description")
  };
  return __jsx(_Container["default"], null, __jsx(_Grid["default"], {
    cols: [1, null, null, 2],
    gap: "s10",
    sx: {
      mt: "s12",
      height: "fit-content"
    }
  }, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "body",
      a: {
        color: "main"
      },
      ml: [0, null, null, "s11"],
      lineHeight: 1.3,
      "h2, h3, h4, h5": {
        margin: 0
      },
      ul: {
        paddingLeft: 40
      },
      "ul br": {
        display: "none"
      },
      "ul li": {
        my: 3,
        paddingLeft: 3
      }
    },
    dangerouslySetInnerHTML: {
      __html: productInfo !== null && productInfo !== void 0 && productInfo.description ? (0, _parseProductDescription["default"])(productInfo.description) : ""
    }
  }), __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      color: "main",
      font: "s",
      px: ["s8", null, null, "s11"],
      py: ["s9", null, null, "s11"],
      mr: [0, null, null, "s11"],
      bg: "beige"
    }
  }, productInfo.technicalData && __jsx(_Box["default"], {
    sx: {
      mb: productInfo.shortDescription ? "s11" : 0
    }
  }, __jsx(_Box["default"], {
    sx: {
      font: "label",
      mb: "s8"
    }
  }, translations["technicalData"]), __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      width: "100%"
    }
  }, productInfo.technicalData.map(function (data) {
    if (data !== null && data !== void 0 && data.name) {
      return __jsx(_Box["default"], {
        sx: {
          display: "flex",
          mb: "s5",
          justifyContent: "space-between"
        }
      }, __jsx(_Box["default"], {
        sx: {
          flexBasis: ["50%", null, null, "55%"]
        }
      }, translations[data.label]), __jsx(_Box["default"], {
        sx: {
          flexBasis: ["45%", null, null, "40%"]
        }
      }, data.label === "capacity" ? parseFloat(data.name) / 1000 : isNaN(data.name) ? data.name.toString().split(",").join(", ") : parseFloat(data.name).toString()));
    }
  }))), productInfo.shortDescription && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      font: "label",
      mb: "s8"
    }
  }, translations["shortDescription"]), __jsx(_Box["default"], {
    sx: {
      font: "s_sans",
      width: "100%",
      lineHeight: 1.6
    },
    dangerouslySetInnerHTML: {
      __html: (0, _parseProductDescription["default"])(productInfo.shortDescription)
    }
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      font: "s_sans",
      mt: "s10",
      lineHeight: 1.6
    }
  }, translations.safetyDescription)))));
};
var _default = ProductDescription2Columns;
exports["default"] = _default;